// Testimonial slider
$(document).ready(function () {
  const swiperOpts = {
    direction: 'horizontal',
    loop: false,
    freeMode: true,
    grabCursor: true,
    spaceBetween: 50,
    slidesPerView: 3,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    mousewheel: {
      invert: true,
      forceToAxis: true
    },
    on: {
      reachEnd: function () {
        // when last slide is reached, go back to first
        setTimeout(() => {
          this.slideTo(0); // jump back to first slide
        }, this.params.autoplay.delay);
      }
    },
    autoplay: {
      delay: 3000,     // 3 seconds
      disableOnInteraction: false // keeps autoplay even after manual swipe
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20,
        allowTouchMove: false
      },
      410: {
        slidesPerView: 1,
        spaceBetween: 20,
        allowTouchMove: false
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 30,
        allowTouchMove: false
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 50
      }
    }
  };

  const swiper = new Swiper('.js-testimonial-slider', swiperOpts);

})

// team slider
$(document).ready(function () {
  const swiperOpts = {
    mode: 'horizontal',
    loop: false,
    resizeReInit: true,
    freeMode: true,
    freeModeFluid: true,
    grabCursor: true,
    createPagination: false,
    spaceBetween: 32,
    slidesPerView: 4.5,
    mousewheel: {
      invert: true,
      forceToAxis: true
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      410: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 1.5,
        spaceBetween: 30
      },
      1024: {
        slidesPerView: 4.5,
        spaceBetween: 32
      }
    }
  }

  const $testimonialSlider = $('.js-testimonial-sliders');
  if ($testimonialSlider.length > 0) {
    const swiper = new Swiper($testimonialSlider, swiperOpts);
  }
})
// Logo list slider
$(document).ready(function () {
  const swiperOpts = {
    mode: 'horizontal',
    loop: false,
    resizeReInit: true,
    grabCursor: true,
    createPagination: false,
    spaceBetween: 25,
    slidesPerView: 4,
    mousewheel: {
      invert: true,
      forceToAxis: true
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 25
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  }

  const $logoSlider = $('.js-logo-list-slider');
  if ($logoSlider.length > 0) {
    const swiper = new Swiper($logoSlider, swiperOpts);
    const slide = $logoSlider.find('.fli-item')
    slide.on('click', (e) => {
      const index = $(e.target).data('index')
      $('.swiper-slide').removeClass('active')
      $('.featured-logos-content__desktop').removeClass('active')
      $(`.fli-item[data-index="${index}"]`).addClass('active')
      $(`.featured-logos-content__desktop[data-index="${index}"]`).addClass('active')
    })
  }
});

$(document).ready(function() {
	$('.popup-youtube').magnificPopup({
		disableOn: 0,
		type: 'iframe',
		mainClass: 'mfp-fade',
		removalDelay: 160,
		preloader: false,

		fixedContentPos: false
	});
  
  $(".thumbs__image .thumb:first-child").addClass("thumb--selected");
  $(".thumbs__image .thumb").click(function(){
    $(".thumbs__image .thumb").removeClass("thumb--selected");
    $(this).addClass("thumb--selected");
    var img = $(this).data("src");
    $(this).parent().parent().find(".primary__image img").attr("src", img);
    if($(this).parent().parent().find(".primary__image a")) { 
      $(this).parent().parent().find(".primary__image a").attr("href", img);
    }
  });
  
  var h = $(".section-featured-collection .has-featured-image .swiper-wrapper").height() - 5;
  $(".section-featured-collection .has-featured-image .swiper-wrapper .swiper-slide:first-child img").css({"object-fit": "cover", "height": h});

  $(".section-id-template--15167404441798__16360549604e4ef2f1 .image-with-text__image .rte").prependTo(".section-id-template--15167404441798__16360549604e4ef2f1 .image-with-text__text--subimage");


  
  $('#product-photos .slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    adaptiveHeight: true
  });

  $('#product-photos .slider').on("afterChange", function (index){
    //change color here
    // alert("change")
    if($(".product-slider__mobile.thumbnail---enabled").length > 0){
      $(".product-gallery__thumbnails.product-slider__thumbnail").css("max-height",$(".product-color_image-wrapper.is--image--active .product-slider__mobile.thumbnail---enabled .slick-slide.slick-active").height()+"px");
      var current__slide = parseInt($(".product-color_image-wrapper.is--image--active .product-slider__mobile.thumbnail---enabled .slick-slide.slick-active").attr("data-slick-index")) + 1;
      $(this).closest("#product-photos").find(".is--image--active .product-gallery__thumbnails .product-gallery__thumbnail").removeClass("is-nav-selected");
      $(this).closest("#product-photos").find(".is--image--active .product-gallery__thumbnails .product-gallery__thumbnail[data-current-slide='"+current__slide+"']").addClass("is-nav-selected");
    }
})
  
  $("body").on("click", ".theme-modal .quantity-wrapper a", function(){
    var n = $(this).parent().find("input").val();
    if($(this).data("quantity") == "up"){
      var qty = parseInt($(this).parent().find("input").val()) + 1;
    }else{
      if(n > 1){
        var qty = parseInt($(this).parent().find("input").val()) - 1;
      }else{
        var qty = parseInt($(this).parent().find("input").val());
      }
    }
    var price = $(this).parent().find("input").data("price");
    var total = qty * price;
    $(".cart-product__price").html(theme.Shopify.formatMoney(total, theme.money_format));
    
    var id = $(this).parent().find("input").data("id");
    jQuery.post('/cart/change.js', { id: id, quantity: qty });
  });
  
});

$(window).resize(function(){
  var h = $(".section-featured-collection .has-featured-image .swiper-wrapper").height() - 5;
  $(".section-featured-collection .has-featured-image .swiper-wrapper .swiper-slide:first-child img").css({"object-fit": "cover", "height": h});

  if($(".product-slider__mobile.thumbnail---enabled").length > 0){
    $(".product-gallery__thumbnails.product-slider__thumbnail").css("max-height",$(".product-color_image-wrapper.is--image--active .product-slider__mobile.thumbnail---enabled .slick-slide.slick-active").height()+"px")
  }
});

$(document).ready(function(){
  $("#page-menu .main-nav li.has-children").click(function(){
    $(this).toggleClass("active");
  });
  if($(".product-slider__mobile.thumbnail---enabled").length > 0){
    $(".product-gallery__thumbnails.product-slider__thumbnail").css("max-height",$(".product-color_image-wrapper.is--image--active .product-slider__mobile.thumbnail---enabled .slick-slide.slick-active").height()+"px")
  }

  $(".product-color_image-wrapper .product-gallery__thumbnails .product-gallery__thumbnail").on("click", function(){
    var slide_index = parseInt($(this).attr("data-current-slide")) - 1;
    $(".product-color_image-wrapper.is--image--active .product-gallery__thumbnails .product-gallery__thumbnail").removeClass("is-nav-selected");
    $(this).addClass("is-nav-selected");
    $(this).closest("#product-photos").find('.is--image--active .product-slider__mobile .slider.slick-slider').slick('slickGoTo', parseInt(slide_index), false); 
  });

  $(".find__fit__sizes_container .find__fit_size").on("click", function(){
    var select__size = $(this).attr("data-value");
    var full_size = $(this).attr("data-full-size");
    $(this).closest(".find__fit__sizes_container").find(".find__fit_size").removeClass("selected");
    $(this).addClass("selected");
    if($(this).closest(".find__fit__content").find(".find__fit__model_container .find__fit__model[data-size='"+select__size+"']").length > 0){
      $(this).closest(".find__fit__content").find(".find__fit__model_container .find__fit__model").hide();
      $(this).closest(".find__fit__content").find(".find__fit__model_container .find__fit__model[data-size='"+select__size+"']").show();
    }
    if(full_size != ''){
      $(this).closest(".find__fit__content").find(".find__fit__model_container .model__measurement_info .model__measurement").html(full_size);
    } 
  });

  if($(window).width() < 701){
    $(".find__fit__content .find__fit__model_container").slick({
      infinite: false,
      slidesToShow: 1.1,
      slidesToScroll: 1.1,
      arrows: false,
      dots: false,
      adaptiveHeight: true
    });
  }
  
});

$(document).ready(function() {
	$('.popup-with-zoom-anim').magnificPopup({
		type: 'inline',

		fixedContentPos: false,
		fixedBgPos: true,

		overflowY: 'auto',

		closeBtnInside: true,
		preloader: false,
		
		midClick: true,
		removalDelay: 300,
		mainClass: 'my-mfp-zoom-in'
	});
});


